import React from 'react'

interface VerticalGoldenSeparatorProps {
    heightOverflow?: number;
    className?: string;
}

const VerticalGoldenSeparator: React.FC<VerticalGoldenSeparatorProps> = ({ heightOverflow = 13, className }) => {
    const overflowPx = heightOverflow * 2;
    return (
        <div className={`flex mx-1 shadow shadow-black ${className}`}>
            <div
                className="bg-[#A07642] w-[2px] border-l border-[#c79857]"
                style={{ height: `calc(100% + ${overflowPx}px)`, transform: `translateY(-${heightOverflow}px)` }}
            ></div>
            <div
                className="bg-[#A07642] w-[2px] border-r border-[#8b6839]"
                style={{ height: `calc(100% + ${overflowPx}px)`, transform: `translateY(-${heightOverflow}px)` }}
            ></div>
        </div>
    )
}

export default VerticalGoldenSeparator